import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredRole, allowedRoles = [] }) => {
  const { user, admin } = useAuth();

  // Check if anyone is logged in
  if (!user && !admin) {
    return <Navigate to="/login" replace />;
  }
 
  // Determine the current user and role
  const currentUser = admin || user;
  const userRole = currentUser?.role;

  // If no role is found, redirect to login
  if (!userRole) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has the exact required role OR is in the allowedRoles array
  if (requiredRole) {
    const hasRequiredRole = userRole === requiredRole;
    const isInAllowedRoles = allowedRoles.length > 0 && allowedRoles.includes(userRole);
    
    if (!hasRequiredRole && !isInAllowedRoles) {
      // Redirect to their appropriate dashboard
      return <Navigate to={getDefaultRoute(userRole)} replace />;
    }
  }

  // All checks passed, render the protected content
  return children;
};

// Helper function to get default route for each role
const getDefaultRoute = (role) => {
  const roleRoutes = {
    'super_admin': '/superadmin',
    'admin': '/admin',
    'service_agent': '/agent',
    'user': '/dashboard'
  };

  return roleRoutes[role] || '/dashboard';
};

export default ProtectedRoute;